/*eslint-disable*/
import Vue from 'vue';
import { Lazyload } from 'vant';
import 'amfe-flexible';
import VConsole from 'vconsole';
import App from './App.vue';
import createRouter from './router';
import createStore from './store';
import createVueI18n from './lang';
import createDirectives from '@/directives';
import Plugins from '@/plugins';

import './style/index.scss';

// VConsole 开发工具
if (window.location.host !== 'abroad-sin-wlogin.shengqugames-corp.com') {
    new VConsole();
}

Vue.config.productionTip = false;
Vue.use(Lazyload);
Vue.use(Plugins);
createDirectives(Vue);

const store = createStore();
const router = createRouter(store);
const i18n = createVueI18n();

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');

export { store };
